(ns frontend.view.data-import.steps.uploading
  (:require [frontend.bootstrap.components :as rbs]
            [common.localization :as loc]
            [frontend.view.data-import.db :as db]
            [frontend.view.data-import.events :as events]
            [frontend.state.current-session :as session]
            [frontend.utils :as utils]))

(defn view []
  (let [step (:import-step @db/import-state)
        job-id (:job-id @db/import-state)
        job (get @session/entities job-id)
        progress (case (:job/status job)
                   :job.status/finished 100.0
                   :job.status/error 100.0
                   :job.status/not-started 0.0
                   :job.status/processing (or (when-let [res (:job/result job)]
                                                (when (string? res)
                                                  (let [prog (js/parseFloat res)]
                                                    (when-not (js/isNaN prog)
                                                      prog))))
                                              0.0)
                   0.0)]
    [:div
     {:class-name "px-4"}
     [:div.downloading-layer
      [:div.text-center
       [:i.spinner]
       [:span.proggress-percentage
        (str (utils/format-with-separators progress 2 false 3) "%")]
       [:p
        {:class-name "text-lg text-center mb-5"}
        (loc/tr :import-uploading-text)]]]]))
